import { useAuthStore } from "@pasta/front-auth-v2";

export function genderize(word: string, civility?: number): string {
  return civility === 1 ? `${word}e` : word;
}

export function useGenderize() {
  const authStore = useAuthStore();
  return (word: string) => genderize(word, authStore.currentUser?.civility);
}
